import asyncActionTypes from '../actions/types.js';
import { setCookie, deleteCookie, getCookie } from '../../scripts/utilities/helpers';
import safeLocalStorage from '../../scripts/utilities/safe-local-storage';
import Moment from 'moment';

const initialState = {
  scheduleChange: {},
  codeErrorSC: {},
  message: '',
  loadingPChangeItineraryRequestStart: undefined,
  // grantAccess
  grantAccessLoading: false,
  grantAccess: '',
  grantAccessError: null,
  changeItinerarySCSuccess: false,
};

const ScheduleChange = ( state = initialState, action ) => {
  switch (action.type) {
    // user change itinerary
    case asyncActionTypes.CHANGE_ITINERARY.START:
      return {
        ...state,
        signInFail: false,
        loadingPChangeItineraryRequestStart: true,
        scheduleChange: {},
      };

    case asyncActionTypes.CHANGE_ITINERARY.SUCCESS:
      return {
        ...state,
        loadingPChangeItineraryRequestStart: false,
        changeItinerarySCSuccess: true,
        scheduleChange:  { ...action.payload.scheduleChange },
        message: action.message,
      };

    case asyncActionTypes.CHANGE_ITINERARY.FAIL:
      return {
        ...state,
        loadingPChangeItineraryRequestStart: false,
        scheduleChange:  { ...action.payload.scheduleChange },
        codeErrorSC: action,
      };
      
    case asyncActionTypes.GET_GRANT_ACCESS.START:
      if ( action.payload.loading ) {
        return {
          ...state,
          grantAccessLoading: true,
        };
      }

      return {
        ...state,
      };
    case asyncActionTypes.GET_GRANT_ACCESS.SUCCESS:
      const expiresGrantAccess = new Date();
      expiresGrantAccess.setTime(expiresGrantAccess.getTime() + ( 180000 ));
  
      const payloadGrantAccess = {
        from: 'MYB',
        GrantId: action.payload.grantAccess,
        timeExpiration: Moment( expiresGrantAccess ).format(),
      };

      // LS and Cookie. 
      if ( action.payload.grantAccess ) {
        setCookie('GAMYB', JSON.stringify( payloadGrantAccess ), null, expiresGrantAccess);
        safeLocalStorage.setItem('GAMYB', JSON.stringify( payloadGrantAccess ));
      }

      return {
        ...state,
        grantAccessLoading: false,
        grantAccess : action.payload.grantAccess,
      };
    case asyncActionTypes.GET_GRANT_ACCESS.FAIL:

      if ( getCookie('GAMYB') || safeLocalStorage.getItem('GAMYB') ) {
        deleteCookie('GAMYB');
        safeLocalStorage.removeItem('GAMYB');
      }

      return {
        ...state,
        grantAccessLoading: true,
        grantAccess: '',
        grantAccessError: action.payload,
      };
    
    default:
      return state;
  }
};

export default ScheduleChange;
